import { useSweepFields } from '../../sweep-fields/useCachedSweepFields';
import {
  ObjectTypesAutocompleteItem,
  ObjectTypesAutocomplete,
} from '../common/ObjectTypesAutocomplete';
import useObjectTypesWithFetch, {
  ObjectTypePropertyFilterType,
} from '../../hooks/useObjectTypesWithFetch';
import { uniqueId } from '../../lib/uniqueId';

export const ActionObjectTypesAutocomplete = ({
  _action,
  crmOrgId,
  onChange,
  disabled,
  objectTypeFilters,
}: {
  _action: UpdateOrCreateAutomationAction;
  crmOrgId: string;
  onChange: (action: AutomationAction) => any;
  disabled?: boolean;
  objectTypeFilters?: ObjectTypePropertyFilterType;
}) => {
  const { searchSweepFields } = useSweepFields();

  const value = _action.actionParams?.objectTypeName?.objectType;

  const setRequiredFields = (requiredFields: SweepField[]) => {
    return requiredFields.map((field) => {
      const action: AutomationActionField = {
        _fieldIds: [field.id as string],
        _id: uniqueId(),
        _isMandatory: true,
        value: '',
      };
      return action;
    });
  };

  const { objectTypes, isLoading } = useObjectTypesWithFetch({
    crmOrgId,
  });

  return (
    <ObjectTypesAutocomplete
      objectTypes={objectTypes}
      objectTypeFilters={objectTypeFilters}
      onChange={async (event: any, newValue: ObjectTypesAutocompleteItem | null) => {
        const { sweepFields: _sweepFields } = await searchSweepFields({
          crmOrgId,
          objectType: newValue?.objectType ? [newValue?.objectType] : undefined,
          includeDescriptionValueSetNameRequired: true,
        });
        const requiredFields = newValue
          ? _sweepFields[newValue.objectType].fields.filter((field) => field?.isRequired)
          : [];

        onChange({
          ..._action,
          actionParams: {
            ..._action.actionParams,
            objectTypeName: {
              objectType: newValue?.objectType ?? '',
              label: newValue?.label ?? '',
            },
            _fields: newValue ? setRequiredFields(requiredFields) : undefined,
            relationsRecords: undefined,
            relationsRecordsToClone: undefined,
          },
        });
      }}
      isLoading={isLoading}
      value={value}
      disabled={disabled}
    />
  );
};
